import React, { useContext } from 'react';
import { ModalDispatchContext } from '../ModalContext';
import ModalDialogWrapper from '../ModalDialogWrapper';
import ModalFooter from '../ModalFooter';

interface OneButtonModalProps {
  body?: string | React.ReactNode;
  buttonLabel?: string | React.ReactNode;
  buttonStyle?: string;
  open?: boolean;
  modalId: string;
  onClose?: () => void;
  title?: string | React.ReactNode;
  trigger?: string;
  variant: 'error' | 'info' | 'input' | 'success';
  clickOverlayToClose?: boolean;
}

export default function OneButtonModal({
  body = '',
  buttonLabel = 'Close',
  buttonStyle = 'yellow',
  open = true,
  modalId,
  onClose = () => {},
  title = '',
  trigger = '',
  variant = 'error',
  clickOverlayToClose = true,
}: OneButtonModalProps) {
  // Modal Context.
  const dispatchModal = useContext(ModalDispatchContext);

  function closeModal() {
    dispatchModal(null);
    onClose();
  }

  return (
    <ModalDialogWrapper
      modalId={`modal-${modalId}`}
      onClose={closeModal}
      open={open}
      title={title}
      trigger={trigger}
      variant={variant}
      clickOverlayToClose={clickOverlayToClose}
    >
      <>
        {body}
        <ModalFooter
          buttons={[
            {
              handler: closeModal,
              id: `btn-close-${modalId}`,
              style: buttonStyle,
              text: buttonLabel,
            },
          ]}
        />
      </>
    </ModalDialogWrapper>
  );
}
